/*
Description: This file contains the code for the conversation row name component. This component 
    is used to display the conversation name and group name in the conversation table.
Author: Jake Michalski
Date: 12/3/2023

*/

import React from 'react';

function renderStatusIndicator(secondsTranscribed, status) {
  // Use startsWith — for dev users the BE appends a ` · via <model>` suffix
  // to the state string (see _state_with_dev_suffix in Conversation.py),
  // so an exact-match would mis-bucket dev convos as "still working." Bare
  // states stay equal to themselves so non-dev users are unaffected.
  const transcribed =
    secondsTranscribed > 0 &&
    typeof status === 'string' &&
    status.startsWith('Transcription Complete!');

  const backgroundColor =
    secondsTranscribed === 0
      ? 'rgb(242, 105, 105)'  // Muted red with 50% opacity
      : transcribed
        ? 'rgb(255, 208, 0)'  // Muted yellow with 50% opacity
        : 'transparent';

  const title =
    secondsTranscribed === 0
      ? 'Start recording your visit'
      : transcribed
        ? `Don't forget to Comprehend the visit`
        : '';

  return (
    <span
      style={{
        width: '10px',
        height: '10px',
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        marginRight: '8px',
        marginLeft: '-18px',
      }}
      title={title}
    />
  );
}

const ConversationRowName = ({ conversation }) => {
  return (
    <th scope="row">
      <div style={{ marginTop: '-1rem', display: 'flex', alignItems: 'center' }}>
        {renderStatusIndicator(conversation.secondsTranscribed, conversation.status)}
        {conversation.conversationName}
      </div>
      <div style={{ marginBottom: '-1rem', fontWeight: 'normal' }}>
        {conversation.patientName}
      </div>
    </th>
  );
};

export default ConversationRowName;
